/* Polymer Elements */
/* Seed Random */
/*
  FIXME(polymer-modulizer): the above comments were extracted
  from HTML and may be out of place here. Review them and
  then delete this comment!
*/
import '@polymer/polymer/polymer-legacy.js';

import '../../js/seedrandom.js';
import { SparkMD5 } from '../../modules/_deprecated/SparkMD5.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import '../style-modules/paper-tooltip-style';

class UserChip extends PolymerElement {
  static get template() {
    return html`
      <style include="paper-tooltip-style">
        :host {
          position: relative;
          padding: 4px;
          border-radius: 4px;
          box-sizing: border-box;
        }
        :host,
        #letter {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        :host(:not([show-name])) {
          border-radius: 100%;
        }
        :host([raised]) {
          @apply (--shadow-elevation-2dp);
        }
        [hidden] {
          display: none !important;
        }
        #profile {
          height: 32px;
          width: 32px;
          overflow: hidden;
          z-index: 1;
          flex-shrink: 0;
          font-size: 14pt;
          position: relative;
          border-radius: 100%;
          @apply --user-chip-profile;
        }
        #gravatar,
        #letter {
          height: inherit;
          width: inherit;
        }
        #gravatar {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
        }
        #letter {
          /* border: 1px solid transparent; */
        }
        #name {
          margin-left: 4px;
          z-index: 1;
          @apply --user-chip-name;
        }
      </style>
      <div id="profile" title="[[getTitle(titleTooltip, email)]]">
        <div id="letter" style$="[[calcLetterStyle(email)]]">
          <span>[[getLetter(email)]]</span>
        </div>
        <img id="gravatar" hidden$="[[!gravatarSrc]]" src$="[[gravatarSrc]]" />
        <paper-tooltip hidden="[[titleTooltip]]">[[name]]</paper-tooltip>
      </div>
      <template is="dom-if" if="[[showName]]">
        <span id="name">[[name]]</span>
      </template>
    `;
  }

  static get is() {
    return 'user-chip';
  }

  static get properties() {
    return {
      colors: {
        type: Array,
        value: () => ['#F44336', '#E91E63', '#9C27B0', '#3F51B5', '#2196F3', '#00BCD4', '#4CAF50', '#FFC107', '#FF9800', '#FF9800']
      },
      email: {
        type: String,
        notify: true
      },
      hideName: {
        type: Boolean,
        value: false
      },
      uid: {
        type: String,
        value: null,
        notify: true,
        observer: '_uidChanged'
      },
      initialsOnly: {
        type: Boolean,
        value: false
      },
      emailOnly: {
        type: Boolean,
        value: false
      },
      fullEmail: {
        type: Boolean,
        value: false
      },
      size: {
        type: Number,
        value: 100
      },
      showName: {
        type: Boolean,
        computed: 'calcShowName(name, hideName)',
        reflectToAttribute: true
      },
      name: {
        type: String,
        computed: 'calcName(initialsOnly, emailOnly, fullEmail, email)',
        notify: true,
        reflectToAttribute: true
      },
      titleTooltip: {
        type: Boolean,
        value: false
      },
      gravatarSrc: {
        type: String,
        computed: 'getGravatarSrc(email)'
      }
    };
  }

  static get observers() {
    return [];
  }

  ready() {
    super.ready();
    if (this.size == 100) {
      // do nothing -- avatar-icon.js exhibits some strange behavior when you set the size on ready, even when set to the 100px it expects.
      // Leaving it alone accordingly ¯\_(ツ)_/¯
    } else {
      // allows for 'size' to be passed into user-chip and set accordingly
      this.$.profile.style.width = `${this.size}px`;
      this.$.profile.style.height = `${this.size}px`;
    }
  }

  and(a, b) {
    return a && b;
  }
  _uidChanged() {
    const { signedIn, user: currentUser } = globalThis.katapultAuth;
    const { uid: currentUserUid, email: currentUserEmail } = currentUser ?? {};

    const { uid } = this;
    if (!signedIn || !uid) return;
    if (uid === currentUserUid)
      this.email = currentUserEmail; // Allow current user's email to be determined without a database call (for mobile offline use).
    else
      globalThis.FirebaseWorker.ref(`user_info/${uid}/email`)
        .once('value')
        .then((s) => (this.email = s.val()));
  }

  calcLetterStyle(x) {
    if (x) {
      Math.seedrandom(x);
      let background = this.colors[Math.floor(Math.random() * this.colors.length)];
      let color = this.colorBrightness(background) > 150 ? 'rgba(0, 0, 0, 0.8)' : 'rgba(255, 255, 255, 0.8)';
      return `background-color: ${background}; color: ${color};`;
    }
    return `background-color: var(--primary-text-color-faded); color: white`;
  }

  calcName(initialsOnly, emailOnly, fullEmail) {
    let initials = null;
    if (initialsOnly) return initials;
    let email = this.email;
    if (email) {
      if (!fullEmail) email = email.split('@')[0];
      if (emailOnly) return email;
      else return initials || email;
    } else return 'Unknown';
  }

  calcShowName(name, hideName) {
    return name && !hideName;
  }

  colorBrightness(color) {
    // Takes in a color and determines how bright it is on a scale from 0-255
    if (color.length == 7) color = color.substring(1);
    var R = parseInt(color.substring(0, 2), 16);
    var G = parseInt(color.substring(2, 4), 16);
    var B = parseInt(color.substring(4, 6), 16);
    return Math.sqrt(R * R * 0.241 + G * G * 0.691 + B * B * 0.068);
  }

  getGravatarSrc(email) {
    if (!email) return '';
    let hashedEmail = SparkMD5.hash(email);
    return `https://www.gravatar.com/avatar/${hashedEmail}?s=${this.size}&d=blank`;
  }

  getLetter() {
    if (this.email) {
      return (this.email || '').slice(0, 1).toUpperCase();
    } else {
      return 'U';
    }
  }

  getTitle() {
    return this.titleTooltip ? this.name : '';
  }
}

window.customElements.define(UserChip.is, UserChip);
